export function getMonthNumberFromDate(dateString) {
    const regex = /^(Janeiro|Fevereiro|Março|Abril|Maio|Junho|Julho|Agosto|Setembro|Outubro|Novembro|Dezembro)-\d{4}$/i;

    const months = {
        'Janeiro': 1,
        'Fevereiro': 2,
        'Março': 3,
        'Abril': 4,
        'Maio': 5,
        'Junho': 6,
        'Julho': 7,
        'Agosto': 8,
        'Setembro': 9,
        'Outubro': 10,
        'Novembro': 11,
        'Dezembro': 12
    };

    if (regex.test(dateString)) {
        const [monthName, year] = dateString?.split('-').map(str => str.trim());
        const monthNumber = months[monthName];

        return monthNumber;
    }
    
    return dateString
}